import React from 'react';
import {Box, Typography, useTheme} from '@mui/material';
import type {IconDefinition} from '@fortawesome/fontawesome-svg-core';
import {IconBadge} from '../../../components';

export interface VerifyContactStepViewHeaderProps {
  icon: IconDefinition;
  title: string;
  subtitle: string;
}

export const VerifyContactStepViewHeader: React.FC<
  VerifyContactStepViewHeaderProps
> = ({icon, title, subtitle}) => {
  const theme = useTheme();
  return (
    <>
      <Box sx={{mb: 1.75}}>
        <IconBadge type={'font'} icon={icon} shape={'rounded'} />
      </Box>
      <Typography variant={'h3'} sx={{fontWeight: 800, letterSpacing: -0.3}}>
        {title}
      </Typography>
      <Typography
        variant={'body2'}
        sx={{color: theme.palette.text.secondary, mt: 0.75, mb: 2.75}}>
        {subtitle}
      </Typography>
    </>
  );
};
